import { t } from '@lingui/macro'
import { Navigate, useLocation, useNavigate } from 'react-router-dom'

import { hasTenantPrefix } from '@/modules/healthblocks/ServerProvider'
import { ErrorLayout } from '@/modules/shared/components/error-layout/ErrorLayout'
import { usePersistedTenant } from '@/modules/shared/hooks/usePersistedTenant'

/**
 * BackCompatRedirect handles legacy unprefixed URLs by redirecting them to /azmm/...
 * Universal routes (/, /login, /link/*) are not redirected and should be handled elsewhere.
 */
export const BackCompatRedirect = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const { persistedTenant, isHydrated } = usePersistedTenant()
  const { pathname, search, hash } = location
  const fallbackTenant = persistedTenant ?? 'azmm'

  // Universal routes that should not be redirected
  const isUniversal =
    pathname === '/' ||
    pathname === '/login' ||
    pathname === '/error' ||
    pathname === '/blocking-admin-message' ||
    pathname.startsWith('/content-preview/') ||
    pathname.startsWith('/program-preview/')

  if (!isHydrated) {
    return null
  }

  if (hasTenantPrefix(pathname)) {
    return (
      <ErrorLayout
        title={t({
          id: 'back-compat-redirect.not-found.title',
          message: 'Pagina niet gevonden',
        })}
        message={t({
          id: 'back-compat-redirect.not-found.message',
          message: 'De pagina die je zoekt bestaat niet of is verplaatst.',
        })}
        cta={{
          label: t({
            id: 'globals.back-to-home',
            message: 'Terug naar beginscherm',
          }),
          onClick: () => navigate('/', { replace: true }),
        }}
      />
    )
  }

  if (pathname.startsWith('/intramuros/olvw_')) {
    return <Navigate to={`/olvw${pathname}${search}${hash}`} replace />
  }
  // This is equivalent to "Redirect legacy unprefixed URLs to /azmm/..."
  // if (pathname.startsWith('/intramuros/azmm_')) {
  //   return <Navigate to={`/azmm${pathname}${search}${hash}`} replace />
  // }

  if (isUniversal) {
    // These should be handled by the universal routes, not redirected
    return <Navigate to='/' replace />
  }

  return <Navigate to={`/${fallbackTenant}${pathname}${search}${hash}`} replace />
}
